/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const lazyLoad = require('public/js/lib/image-lazy-load')();

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/

	(function SearchListingModule() {
		$onReady({
			rp$, window,
			label: 'search_listing',
			fn: function () {
				function numberWithCommas(x) {
					return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}

				function resultCountTween($el, start, end, decrement) {
					let step = 9;
					let diff = Math.abs(start - end);

					if (start === end) {
						$el.text(numberWithCommas(end));
						return; // Do nothing
					}

					if (decrement === true && start <= end) {
						$el.text(numberWithCommas(end));
						return;
					} else if (decrement === false && start >= end) {
						$el.text(numberWithCommas(end));
						return;
					}

					if (diff > 100) {
						step = Math.round((diff / 100) * 9);
					}

					start = (decrement === true) ? start - step : start + step;

					$el.text(numberWithCommas(start));

					if (start !== end) {
						setTimeout(function () {
							resultCountTween($el, start, end, decrement);
						}, 1);
					}
				}

				function handleNewCount($countEle, newCount) {
					var start = parseInt($countEle.text().toString().replace(/[^\d]/g,''), 10) || 0;
					var end = parseInt(newCount.toString().replace(/[^\d]/g,''), 10) || 0;
					var decrement = (start > end) ? true : false;
					resultCountTween($countEle, start, end, decrement);
				}

				rp$('.search-listing-module').parent().on('click', '.catalog-info-show-more', function HookMoreInfoClick(evt) {
					evt.preventDefault();

					var fullInfo = rp$(this).data('full-info');
					rp$(this).parent().html(fullInfo);
				});

				rp$('.search-listing-module').parent().on('click', '.fitment-more', function HookMoreInfoClick(evt) {
					evt.preventDefault();

					rp$(this).parent().find('.hide').removeClass('hide');
					rp$(this).remove();
				});

				rp$('.search-listing-module').parent().on('click', '.pagination-link', function HookPaginationClick(evt) {
					evt.preventDefault();

					var page = rp$(this).data('page');
					rp$(document).trigger('searchResults:pageChange', page);

					// Scroll to top of results
					rp$('html, body').animate({ scrollTop: 0 }, 'slow');
				});

				/* Handle Search Results Request
				.*-----------------------------------------*/
				function HandleSearchResultsRequest(evt) {
					rp$('.search-listing-module').overlaySpinner({animation:{top: '200px'}});
				}
				rp$(document).off('searchResults:request', HandleSearchResultsRequest);
				rp$(document).on('searchResults:request', HandleSearchResultsRequest);

				/* Handle Search Results Error
				.*-----------------------------------------*/
				function HandleSearchResultsError(evt) {
					rp$('.search-listing-module').overlaySpinner.remove();
					rp_app.notify.add_notification(`We're sorry, but the search results failed to load. Please refresh and try again or contact support.`, 'error');
				}
				rp$(document).off('searchResults:error', HandleSearchResultsError);
				rp$(document).on('searchResults:error', HandleSearchResultsError);

				/* Handle Search Results Response
				.*-----------------------------------------*/
				function HandleSearchResultsResponse(evt, response) {
					var $listingModule = rp$('.search-listing-module');
					$listingModule.overlaySpinner.remove();

					// Detach lazy loading from previous DOM elements
					const detachedElements = document.querySelectorAll(`.search-listing-module ${lazyLoad.getSelector()}`);
					if (detachedElements && detachedElements.lenght) {
						lazyLoad.detatch($detachedElements);
					}

					if(response.listings_html) {
						$listingModule.replaceWith(response.listings_html);
						if (typeof rp$.fn.add_to_cart === 'function') {
							rp$('.search-listing-module').find('.add-to-cart.enabled').add_to_cart();
						}
					}

					rp$('.result-count').each(function CountEle_Iterator(/*idx*/) {
						handleNewCount(rp$(this), response.count);
					});
					rp$('.result-ymm-text').html(response.ymm_text);
					rp$('.result-text').html(response.query);
					rp$('.search-bar-component input[type=text]').val(response.query);

					// Attach to new elements
					lazyLoad.attach(document.querySelectorAll(`.search-listing-module ${lazyLoad.getSelector()}`));
				}
				rp$(document).off('searchResults:response', HandleSearchResultsResponse);
				rp$(document).on('searchResults:response', HandleSearchResultsResponse);
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
